import React from "react";
import { sxIcons } from "../../settings/shared/sxIcons";

const ToolIcon = ({ tool }) => {
    const icon = tool?.icon;
    const color = tool?.iconColor || '#6c757d';
  
    // 0️⃣ Check if icon is a string and exists in sxIcons
    if (typeof icon === 'string' && sxIcons[icon]) {
      return <span className="tool-img">{sxIcons[icon]}</span>;
    }
  
    // 1️⃣ SVG STRING
    if (
      typeof icon === 'string' &&
      (icon.trim().startsWith('<svg') || icon.trim().startsWith('<?xml'))
    ) {
      return (
        <span
          className="tool-img svg-icon"
          dangerouslySetInnerHTML={{ __html: icon }}
        />
      );
    }
  
    // 2️⃣ FontAwesome
    if (typeof icon === 'string' && icon.startsWith('fa')) {
      return (
        <span className="palette-node-icon" style={{ color }}>
          <i className={icon} />
        </span>
      );
    }
  
    // 3️⃣ Image URL or local path
    if (
      typeof icon === 'string' &&
      (icon.startsWith('http') ||
        icon.startsWith('/') ||
        icon.match(/\.(png|jpg|jpeg|gif|webp|svg)$/))
    ) {
      return (
        <img
          src={icon}
          alt={tool.displayName}
          className="tool-img"
          style={{ width: 22, height: 22 }}
          onError={(e) => (e.currentTarget.style.display = 'none')}
        />
      );
    }
  
    // 4️⃣ React Component (SVG import)
    if (typeof icon === 'function' || React.isValidElement(icon)) {
      return <span className="tool-img">{icon}</span>;
    }
  
    // 5️⃣ Fallback – text avatar
    return (
      <span
        className="text-ellipsis"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#fff',
          backgroundColor: color,
          fontWeight: 700,
          textAlign: 'center',
          lineHeight: '18px',
          fontSize: 14,
          width: 22,
          height: 22,
          borderRadius: '50%',
        }}
      >
        {tool?.displayName?.[0]?.toUpperCase() || '?'}
      </span>
    );
  };
  
  export default ToolIcon;
  